import React from "react";

const Products = () => {
  const productList = [
    {
      title: "CRM for Travel Booking Agencies",
      description: "A comprehensive CRM solution designed specifically for managing client bookings, itineraries, and operations for travel agencies.",
      link: "#contact",
      isExternal: false,
      icon: (
        <svg viewBox="0 0 24 24" width="48" height="48" style={{ fill: "#007bff" }}>
          <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L14 19v-5.5L21 16z" />
        </svg>
      )
    },
    {
      title: "Micropatho",
      description: "A complete pathology lab management solution that streamlines report generation from sample collection to final delivery. Micropatho supports full body check-up reports, haematology, biochemistry, microbiology, and histopathology — enabling labs to generate, manage, and share accurate diagnostic reports with ease and speed.",
      link: "http://micropatho.in/",
      isExternal: true,
      icon: (
        <svg viewBox="0 0 24 24" width="48" height="48" style={{ fill: "#007bff" }}>
          <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z" />
        </svg>
      )
    },
    {
      title: "Advanced User Management Software",
      description: "An enterprise-grade user management and access control software system featuring multi-tenant SaaS support.",
      link: "#contact",
      isExternal: false,
      icon: (
        <svg viewBox="0 0 24 24" width="48" height="48" style={{ fill: "#007bff" }}>
          <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" />
        </svg>
      )
    }
  ];

  const handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    const target = document.querySelector(targetId);
    if (target) {
      let top_space = 0;
      const header = document.getElementById("header");
      if (header) {
        top_space = header.offsetHeight;
        if (!header.classList.contains("header-scrolled")) {
          top_space -= 20;
        }
      }
      window.scroll({
        top: target.offsetTop - top_space,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <style>{`
        #products {
          padding: 80px 0;
        }
        #products .product-box {
          padding: 40px 30px;
          position: relative;
          overflow: hidden;
          border-radius: 10px;
          background: #fff;
          box-shadow: 0 10px 29px 0 rgba(68, 88, 144, 0.1);
          transition: all 0.3s ease-in-out;
          text-align: center;
          border: 1px solid #eef3f9;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
        }
        #products .product-box:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 35px 0 rgba(68, 88, 144, 0.15);
        }
        #products .product-icon {
          margin: 0 auto 20px auto;
          display: inline-block;
        }
        #products .product-title {
          font-weight: 700;
          margin-bottom: 15px;
          font-size: 20px;
          line-height: 26px;
        }
        #products .product-title a, #products .product-title span {
          color: #111;
          transition: color 0.3s ease;
        }
        #products .product-title a:hover {
          color: #007bff;
        }
        #products .product-description {
          font-size: 15px;
          line-height: 24px;
          margin-bottom: 25px;
          color: #555;
          flex-grow: 1;
        }
        #products .btn-product-action {
          font-family: "Montserrat", sans-serif;
          font-weight: 500;
          font-size: 14px;
          letter-spacing: 0.5px;
          display: inline-block;
          padding: 10px 24px;
          border-radius: 5px;
          transition: 0.5s;
          color: #fff;
          background: #007bff;
          text-decoration: none;
          margin-top: auto;
        }
        #products .btn-product-action:hover {
          background: #0062cc;
        }
      `}</style>
      <section id="products" className="wow fadeIn">
        <div className="container">
          <header className="section-header">
            <h3>Our Products</h3>
            <p>
              Explore our innovative range of digital software products designed to streamline operations and enhance productivity.
            </p>
          </header>

          <div className="row mt-5 justify-content-center">
            {productList.map((prod, index) => (
              <div key={index} className="col-lg-4 col-md-6 mb-4 wow fadeInUp" data-wow-delay={`${index * 0.1}s`}>
                <div className="product-box">
                  <div>
                    <div className="product-icon">
                      {prod.icon}
                    </div>
                    <h4 className="product-title">
                      {prod.isExternal ? (
                        <a href={prod.link} target="_blank" rel="noopener noreferrer">
                          {prod.title}
                        </a>
                      ) : (
                        <a href={prod.link} onClick={(e) => handleSmoothScroll(e, prod.link)}>
                          {prod.title}
                        </a>
                      )}
                    </h4>
                    <p className="product-description">
                      {prod.description}
                    </p>
                  </div>
                  {prod.isExternal ? (
                    <a href={prod.link} className="btn-product-action" target="_blank" rel="noopener noreferrer">
                      Visit Product Website
                    </a>
                  ) : (
                    <a href={prod.link} className="btn-product-action" onClick={(e) => handleSmoothScroll(e, prod.link)}>
                      Inquire Now
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Products;
